// DOC: https://vuex.vuejs.org/en/actions.html

import axios from 'axios';
import Raven from 'raven-js';

import {
    OEPFELCHASPER_API_ORDERABLE_PRIVATE,
    OEPFELCHASPER_API_ORDERABLE_BUSINESS,
    OEPFELCHASPER_API_ORDERABLE,
    OEPFELCHASPER_API_ORDER_PRIVATE,
    OEPFELCHASPER_API_ORDER_BUSINESS,
    OEPFELCHASPER_API_ORDER_TESTBASKET,
    OEPFELCHASPER_API_ORDER_COUPON,
    OEPFELCHASPER_API_CREATE_QUOTE,
} from './api';

export default {
    // fetchOrderableBusiness({ commit }) {
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .get(OEPFELCHASPER_API_ORDERABLE_BUSINESS)
    //             .then((response) => {
    //                 // set orderable data
    //                 commit('setOrderable', response.data);

    //                 // set initial state and render first baskets
    //                 commit('setInitialState');
    //                 commit('updatePeople', 1);
    //                 commit('calculateBaskets');

    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //                 Raven.captureException(error);
    //             });
    //     });
    // },
    // fetchOrderablePrivate({ commit }) {
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .get(OEPFELCHASPER_API_ORDERABLE_PRIVATE)
    //             .then((response) => {
    //                 // set orderable data
    //                 commit('setOrderable', response.data);

    //                 // set initial state and render first baskets
    //                 commit('setInitialState');
    //                 commit('updatePeople', 1);
    //                 commit('calculateBasketsPrivate');

    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //                 Raven.captureException(error);
    //             });
    //     });
    // },
    fetchOrderableBusiness({ commit }, { id, lang }) {
        let url = OEPFELCHASPER_API_ORDERABLE_BUSINESS.replace('{zip}', id);
        url = url.replace('{lang}', lang);

        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then((response) => {
                    // set orderable data
                    response.data.product_groups.map((p, index) => {
                        const variants = [];
                        p.products.map((x) => {
                            const kg = x.weight.replace(' kg', '');
                            const data = {
                                id: x.id,
                                kg: parseInt(kg, 10),
                                price: x.price,
                            };
                            variants.push(data);
                        });
                        p.variants = variants;
                        p.appetites = p.products[0].appetites;
                    });

                    commit('setDeliveryFee', response.data.location.delivery_price);
                    commit('setProductGroups', response.data.product_groups);

                    commit('setValidPostalCode', !response.data.location.is_on_request);
                    commit('updateExtra', response.data.addons);

                    commit('updateBasketExtra', {
                        monday: [],
                        wednesday: [],
                    });
                    commit('setInitialState');
                    commit('updatePeople', 1);

                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    Raven.captureException(error);
                });
        });
    },
    fetchOrderablePrivate({ commit }, { id, lang }) {
        let url = OEPFELCHASPER_API_ORDERABLE_PRIVATE.replace('{zip}', id);
        url = url.replace('{lang}', lang);

        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then((response) => {
                    // set orderable data
                    response.data.product_groups.map((p, index) => {
                        const variants = [];
                        p.products.map((x) => {
                            const kg = x.weight.replace(' kg', '');
                            const data = {
                                id: x.id,
                                kg: parseInt(kg, 10),
                                price: x.price,
                            };
                            variants.push(data);
                        });
                        p.variants = variants;
                        p.appetites = p.products[0].appetites;
                    });

                    commit('setDeliveryFee', response.data.location.delivery_price);
                    commit('setProductGroups', response.data.product_groups);

                    commit('setValidPostalCode', !response.data.location.is_on_request);
                    commit('updateExtra', response.data.addons);

                    commit('updateBasketExtra', {
                        monday: [],
                        wednesday: [],
                    });
                    commit('setInitialState');
                    commit('updatePeople', 1);
                    commit('calculateBasketsPrivate');

                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    Raven.captureException(error);
                });
        });
    },
    sendOrder({ state }) {
        return new Promise((resolve, reject) => {
            axios
                .post(OEPFELCHASPER_API_ORDER_BUSINESS, { ...state.order })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    Raven.captureException(error);
                });
        });
    },
    // sendOrderBusiness({ state }) {
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .post(OEPFELCHASPER_API_ORDER_BUSINESS, { ...state.order })
    //             .then((response) => {
    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //                 Raven.captureException(error);
    //             });
    //     });
    // },
    // sendOrderPrivate({ state }) {
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .post(OEPFELCHASPER_API_ORDER_PRIVATE, { ...state.order })
    //             .then((response) => {
    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 reject(error);
    //                 Raven.captureException(error);
    //             });
    //     });
    // },
    sendOrderVoucher({ state }, { amount }) {
        return new Promise((resolve, reject) => {
            axios
                .post(OEPFELCHASPER_API_ORDER_COUPON, {
                    coupon: {
                        amount,
                        deliveryAdress: { ...state.order.delivery_address },
                        invoiceAdress: { ...state.order.invoice_address },
                    },
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    Raven.captureException(error);
                });
        });
    },
    sendOrderTestBasket({ state }) {
        return new Promise((resolve, reject) => {
            axios
                .post(OEPFELCHASPER_API_ORDER_TESTBASKET, {
                    order: {
                        ...state.order,
                    },
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    Raven.captureException(error);
                });
        });
    },
    sendQuote({ state }, { numberEmployees }) {
        // create-quote.json is a v2 endpoint and expects the legacy address schema,
        // not the v3 field names stored in state.order
        const legacyAddress = address => ({
            firm: address.company,
            email: address.email_contact,
            prename: address.firstname,
            surname: address.lastname,
            floorOrDepartment: address.additional_shipping,
            street: address.street,
            postalCode: address.zip,
            place: address.city,
            phone: address.phone,
            mobilePhone: address.mobile,
        });
        return new Promise((resolve, reject) => {
            axios
                .post(OEPFELCHASPER_API_CREATE_QUOTE, {
                    quote: {
                        numberEmployees,
                        deliveryAdress: legacyAddress(state.order.delivery_address),
                        invoiceAdress: legacyAddress(state.order.invoice_address),
                    },
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    Raven.captureException(error);
                });
        });
    },
    updateMode({ commit }, mode) {
        commit('setMode', mode);
    },
    updateActiveSubscriptionType({ commit }, { id }) {
        commit('updateActiveSubscriptionType', id);
        commit('updateBasketsSubscriptionType');
    },
    updatePeople({ commit }, { people, mode }) {
        commit('updatePeople', people);
        if (mode === 'private') {
            commit('calculateBasketsPrivateByPeople');
        } else {
            commit('calculateBaskets', { mode });
        }
    },
    updateAppetite({ commit }, { name, mode }) {
        commit('updateAppetite', name);
        commit('calculateBaskets', { mode });
    },
    updateAmounts({ commit }, { amount, day }) {
        commit('updateAmounts', { amount, day });
    },
    saveEdit({ commit }, { baskets, intervals, subscriptionType }) {
        commit('updateBaskets', baskets);
        commit('updateIntervals', intervals);
        commit('updateActiveSubscriptionType', subscriptionType);
        commit('updateBasketsSubscriptionType');
        commit('updateBasketExtraBasedOnBasket');
        commit('saveEdit');
    },
    saveEditPrivate(
        { commit },
        { baskets, intervals, subscriptionType, privateDeliveryDay },
    ) {
        commit('updateBasketsPrivate', { baskets, privateDeliveryDay });
        commit('updateIntervalsPrivate', { intervals, privateDeliveryDay });
        // commit('updateActiveSubscriptionType', subscriptionType);
        // commit('updateBasketsSubscriptionType');
        commit('updatePrivateDeliveryDay', privateDeliveryDay);
    },
    updateSameInvoiceAddress({ commit }) {
        commit('updateSameInvoiceAddress');
    },
    updateOrder({ commit }, { invoiceAddress, deliveryAddress, attentionBy, comment }) {
        commit('updateDeliveryAddress', deliveryAddress);
        commit('updateAttentionBy', attentionBy);
        commit('updateComment', comment);
        commit('updateInvoiceAddress', { invoiceAddress, deliveryAddress });
    },
    prepareOrder({ commit }) {
        commit('prepareOrder');
    },
    showLoadingModal({ commit }, { message }) {
        commit('setLoadingModalMessage', message);
        commit('toggleLoadingModalVisible');
    },
    hideLoadingModal({ commit }) {
        commit('setLoadingModalMessage', '');
        commit('toggleLoadingModalVisible');
    },
    resetOrder({ commit, state }) {
        if (!state.order.attention_by.length) {
            commit('updateBasketExtra', {
                monday: [],
                wednesday: [],
            });
        }
    },
    resetOrderPLZ({ state, commit, dispatch }) {
        commit('setInitialState');
        dispatch('updatePeople', { people: 1, mode: state.mode });

        if (state.mode === 'business') {
            commit('updateIntervals', {
                monday: 1, // interval id
                wednesday: 1,
            });
            commit('updateActiveSubscriptionType', state.subscriptionType);
            commit('updateBasketsSubscriptionType');
        } else {
            commit('updateIntervalsPrivate', {
                intervals: 1,
                privateDeliveryDay: 'monday',
            });
            commit('updateIntervalsPrivate', {
                intervals: 1,
                privateDeliveryDay: 'wednesday',
            });
            const subscriptionType = (state.orderable.product_groups ? state.orderable.product_groups.find(
                s => s.id === state.subscriptionType,
            ) : []);
            const p = subscriptionType.products[0];
            const deliveryDays = p.delivery_days;

            if (p.preferred_delivery_day) {
                const preferredDay = p.preferred_delivery_day;
                commit('updatePrivateDeliveryDay', preferredDay === 1 ? 'monday' : 'wednesday');
            } else {
                if (!deliveryDays.some(p => p === 1)) {
                    commit('updatePrivateDeliveryDay', 'wednesday');
                }
                if (!deliveryDays.some(p => p === 3)) {
                    commit('updatePrivateDeliveryDay', 'monday');
                }
            }
            commit('updateActiveSubscriptionType', state.subscriptionType);
            commit('updateBasketsSubscriptionType');
        }
    },
};



// WEBPACK FOOTER //
// ./static/js/Order/store/actions.js